import { get, post, put } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async getJobRolesByFacilityId(facilityId) {
    return await get(uriWithQueryStringParams("ObvJobRole", { facilityId }));
  },

  async saveJobRole(jobRole) {
    return await post("ObvJobRole", jobRole);
  },

  async setActiveStatus(jobRole) {
    return await put("ObvJobRole/ActiveStatus", jobRole);
  },

  async updateJobRoleName(jobRole) {
    return await put("ObvJobRole/JobRoleName", jobRole);
  },

  async getJobRoleTypes(facilityId) {
    return await get(
      uriWithQueryStringParams("ObvJobRole/Types", { facilityId })
    );
  },

  async cloneJobRolesToFacilities(requestModel) {
    return await post("ObvJobRole/Copy", requestModel);
  }
};
